export enum SorterOrderType {
  ASC = 'asc',
  DESC = 'desc',
}
